<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="procedimentoListaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Procedimentos: {{ dados ? dados.search : 'Carregando...' }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!procedimentos || !procedimentos.length" msg="Nenhum procedimento identificado." />

                        <div v-else>
                            <div class="alert alert-info" v-if="info">
                                {{ info }}
                            </div>

                            <az-input
                                sizing="sm"
                                type="button-group"
                                :optionsList="[
                                    { id: 'T', search: 'Todos' },
                                    { id: 'S', search: 'Selecionados' },
                                ]"
                                optionsDisplay="search"
                                optionsData="id"
                                v-model="viewMode"
                                @input="trocar_filtro()" />

                            <template v-if="viewMode == 'T'">

                                <az-input
                                    sizing="sm"
                                    icon="fa fa-filter fa-fw"
                                    placeholder="Todas as Especialidades..."
                                    type="select"
                                    :optionsList="lista_especialidades"
                                    optionsData="id_especialidade"
                                    v-model="id_especialidade" />

                                <az-input
                                    sizing="sm"
                                    icon="fa fa-filter fa-fw"
                                    placeholder="Todas as Classificações..."
                                    type="select"
                                    optionsData="id_classe_procedimento"
                                    service="classe_procedimentos.index"
                                    optionsMode="aql"
                                    v-model="id_classe_procedimento"
                                    @input="buscarItems ()" />

                                <az-input
                                    sizing="sm"
                                    icon="fa fa-search fa-fw"
                                    placeholder="Pesquisar..."
                                    v-model="search">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">
                                                {{ selecionados.length }}/{{ lista.length }}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>

                                <button type="button" class="btn btn-sm btn-outline-primary mb-1" v-if="lista.length > 0" @click="marcar_todos()">Todos</button>

                                <az-input
                                    v-if="false"
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="TODOS"
                                    v-model="todos"
                                    @click="trocando = true;" />

                            </template>

                            <table class="table table-sm border-0 table-responsive" v-if="lista_classes && lista_classes.length">
                                <tr>
                                    <td class="text-nowrap">
                                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                                            <span class="badge badge-success mr-1" >
                                                {{ classe }}
                                            </span>
                                        </a>
                                    </td>
                                </tr>
                            </table>

                            <div v-for="(procedimento, idx) in lista" :key="idx">
                                <az-input 
                                    sizing="sm"
                                    type="checkbox-group"
                                    :label="procedimento.search"
                                    :edicao="viewMode == 'T'"
                                    v-model="procedimento.selecionado" />
                            </div>
                        </div>
                        <pre v-if="1 == 0" class="alert alert-info">{{ procedimentos }}</pre>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from './forms/AzInput.vue';
import AzSubmit from '../util/AzSubmit.vue';
import AzEmptyState from '../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            dados: null,
            procedimentos: [], 
            model: null,
            id: null, 
            viewMode: 'S',
            search: "", 
            id_especialidade: "", 
            id_classe_procedimento: "", 
            trocando: false, 
            callback: null, 
        }
    },

    components: { 
        AzInput,
        AzSubmit,
        AzEmptyState
    },

    props: ['info'], 

    computed: { 
        lista_classes: function () { 
            return _.uniq(
                this.lista.filter(item => item.js_classes)
                    .flatMap(item => item.js_classes)
                    .sort()
            );
        },

        lista_especialidades: function () { 
            if ( !this.procedimentos )
                return [];

            return _.orderBy(
                _.uniqBy(this.procedimentos.filter(item => item.especialidade)
                    .map(item => item.especialidade), 'id_especialidade'),
                'search'
            );
        },

        lista: function () { 
            if ( this.viewMode == 'S' ) { 
                return this.procedimentos.filter(item => item.selecionado);
            }

            const reg = this.$util.getregex(this.search);

            return this.procedimentos.filter(item => this.viewMode == 'T' || item.selecionado)
                .filter(item => ( !this.id_especialidade || ( item && item.id_especialidade == this.id_especialidade ) )
                    && ( !this.id_classe_procedimento || ( item && item.id_classe_procedimento == this.id_classe_procedimento ) )
                    && ( item.viewMode == 'S' || !this.search || reg.test(JSON.stringify(item)))
                );
        },

        selecionados: function () { 
            return this.procedimentos.filter(item => item && item.selecionado);
        },

        todos: { 
            get() {
                return this.lista.findIndex(item => !item.selecionado) < 0;
            },
            set(value) {
                if ( this.trocando ) { 
                    
                    this.lista.forEach(element => {
                        element.selecionado = value;
                    });

                    this.trocando = false;

                }
            } 
        }
    },

    methods: { 
        marcar_todos () { 
            let value = this.lista.findIndex(item => !item.selecionado) >= 0 ? true : false;

            this.lista.forEach(element => {
                element.selecionado = value;
            });
        },

        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },
        
        trocar_filtro () { 
            this.trocando = true;

            this.$nextTick(() => { 
                this.trocando = false;
            });
        },

        atualizar () { 
            if ( this.callback ) { 

                this.callback(this.procedimentos.filter(item => item.selecionado));
                
            } else { 

                this.$util.atualizar(this, { 
                    service: 'procedimentos',
                    func: 'store_lista',
                    dados: { 
                        id: this.id,
                        model: this.model, 
                        items: this.procedimentos,
                    },
                    modal: 'procedimentoListaModal',
                    callback: res => { 
                        this.$emit('refresh', res);
                    } 
                });

            }
        },

        abrir(model, id, callback = null) { 
            this.search = "";
            this.viewMode = 'S';
            this.model = model;
            this.id = id;   
            this.callback = callback;

            this.load();
            
            $('#procedimentoListaModal').modal('show');
        },
        load() { 

            this.dados = [];
            this.medicos = [];

            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: 'procedimentos.lista',
                        id: "lista",
                        with: null,
                        parms: {
                            with: null,
                            id: this.id,
                            model: this.model, 
                        }
                    },
                    {
                        name: 'procedimentos.index',
                        id: "procedimentos",
                        parms: {
                            agenda: this.model != 'modeloProntuario', 
                            modelo: this.model == 'modeloProntuario', 
                            tags: true, 
                        }
                    }
                ]
            };

            return this.axios.post("/aql", query)
                .then(res => {
                    if (res.data.lista.status == 200) {
                        this.dados = res.data.lista.data;
                    }

                    if (res.data.procedimentos.status == 200) {
                        this.procedimentos = res.data.procedimentos.data.map(item => { 
                            let selec = this.dados.procedimento_lista.find(el => el.id_procedimento == item.id_procedimento);

                            item.selecionado = selec ? true : false;
                            item.item_lista = selec;

                            return item;
                        });

                        if ( !this.lista.length ) { 
                            this.viewMode = 'T';
                        }

                    }
                })
                .finally(() => { 
                    this.$store.commit("loading", false);
                });

        }
    }
}
</script>